import React, { FC, useEffect, useMemo } from 'react';
import { Grid, List, ListItemText } from '@mui/material';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { TAB_QUERY_PARAM } from 'pages/ValuationsAllocation/common/constants/valuations';
import { scrollToTop, setQueryString } from 'utilities';
import {
  IconContainer,
  ListContainer,
  ListIconContainer,
  ListItemBox,
  ListItemStyled,
  MessageContainer,
  StyledErrorOutlineIcon,
  StyledNotificationIcon,
  Title,
} from './styles';
import { InvalidTablesMessageProps } from './types';

const TITLE = 'To proceed, please correct the highlighted errors in the table cells or invalid characters in the approach names:';

const InvalidTablesMessage: FC<InvalidTablesMessageProps> = props => {
  const { invalidTables = [], title } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const parsedQuery = useMemo(() => queryString.parse(location.search), [location.search]);
  const { [TAB_QUERY_PARAM]: approachId } = parsedQuery;

  useEffect(() => {
    scrollToTop();
  }, [invalidTables]);

  const redirectToTab = (id: string) => {
    if (approachId !== id) {
      setQueryString({
        navigate,
        paramName: TAB_QUERY_PARAM,
        paramValue: id,
        pathname: location.pathname,
        searchParams: queryString.stringify(parsedQuery),
        shouldPushPath: true,
      });
    }
  };

  return (
    <MessageContainer id="invalid-tables-message" sx={title ? { pb: 2.5, ml: 1.5 } : {}}>
      <Grid container alignItems="center" justifyContent="flex-start">
        <IconContainer item>
          <StyledNotificationIcon />
        </IconContainer>
        <Grid item>
          <Title>{title ?? TITLE}</Title>
        </Grid>
      </Grid>
      {Boolean(invalidTables?.length) && (
        <ListContainer>
          <List>
            {invalidTables.map((approach: { approachType?: string; id: string; name: string }) => {
              const { approachType, id, name } = approach;
              return (
                <ListItemStyled key={`${name}-${id}`}>
                  <ListItemBox onClick={() => redirectToTab(id)}>
                    <ListIconContainer>
                      <StyledErrorOutlineIcon />
                    </ListIconContainer>
                    <ListItemText primary={name} secondary={approachType ? `(${approachType})` : null} />
                  </ListItemBox>
                </ListItemStyled>
              );
            })}
          </List>
        </ListContainer>
      )}
    </MessageContainer>
  );
};

export default InvalidTablesMessage;
